var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnNavMore = function SvgIcnBtnNavMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 3C9.33325 3.55228 8.88554 4 8.33325 4C7.78097 4 7.33325 3.55228 7.33325 3C7.33325 2.44772 7.78097 2 8.33325 2C8.88554 2 9.33325 2.44772 9.33325 3ZM9.33325 7.66634C9.33325 8.21863 8.88554 8.66634 8.33325 8.66634C7.78097 8.66634 7.33325 8.21863 7.33325 7.66634C7.33325 7.11406 7.78097 6.66634 8.33325 6.66634C8.88554 6.66634 9.33325 7.11406 9.33325 7.66634ZM8.33325 13.3327C8.88554 13.3327 9.33325 12.885 9.33325 12.3327C9.33325 11.7804 8.88554 11.3327 8.33325 11.3327C7.78097 11.3327 7.33325 11.7804 7.33325 12.3327C7.33325 12.885 7.78097 13.3327 8.33325 13.3327Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnNavMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_nav_more.4637d072.svg";
export { ForwardRef as ReactComponent };